import TpJobAdmin from './TpJobAdmin';

export default class AllTpJobsAdmin extends TpJobAdmin {}
